import * as React from "react";

// Default context values
const values = {
  content: null,
};

const ContentDetailContext = React.createContext(values);
export default ContentDetailContext;
